import { GenericTextFilter } from '@app/core/list-view/base-filters/GenericTextFilter';
import { createFilter } from '@app/core/list-view/types';
import { Station } from '@app/core/types/stations';
import { parseAsString } from 'nuqs';
import { defineMessage } from 'react-intl';

/**
 * Local toolbar filters for the admin stations list (name search).
 */
export const ADMIN_STATIONS_FILTERS_CONFIG = [
  createFilter({
    name: 'name',
    label: defineMessage({
      id: 'common.text.name',
      defaultMessage: 'Nombre',
    }),
    parser: parseAsString.withDefault(''),
    isPermanent: true,
    component: GenericTextFilter,
    componentProps: {
      placeholder: defineMessage({
        id: 'admin.stations.filters.namePlaceholder',
        defaultMessage: 'Buscar por nombre',
      }),
      sx: {
        width: '22ch',
      },
    },
    filterFn: (item, value) => {
      const station = item as Station;
      const q = typeof value === 'string' ? value.trim().toLowerCase() : '';
      if (!q) {
        return true;
      }
      return station.name.toLowerCase().includes(q);
    },
  }),
];
